export const getPriceVisibility = (state = {visibility: true}, action) => {
    switch(action.type) {
        case "change3":
            return {
                visibility: action.payload
            }
        default:
            return state;
    }
}